import { Flex } from '@mantine/core';

import HomeSkeletonLayout from './components/HomeSkeleton';
import HomeContest from './components/HomeContest';
import { useHomePromoContests } from './hooks/useHomePromoContests';
import { useHomeContestRefresh } from './hooks/useHomeContestRefresh';

function HomeContests({ order }: { order?: number }) {
  const { data, isShowContestThumbnailEnabled } = useHomePromoContests();
  const { data: contests, isError, isLoading: isFeatureContestLoading } = data;
  const hasContests = contests?.length > 0;
  const { registerSection } = useHomeContestRefresh();

  if (isFeatureContestLoading) {
    return <HomeSkeletonLayout isLoading order={order} />;
  }

  if (!hasContests || isError) {
    return null;
  }

  return (
    <Flex /* eslint-disable-line local-rules/use-theme-tokens */ gap={16} direction="column" style={{ order }}>
      {contests.map((contestsRow, index) => (
        <HomeContest
          // eslint-disable-next-line react/no-array-index-key
          key={`${index}`}
          {...contestsRow}
          isShowContestThumbnailEnabled={isShowContestThumbnailEnabled}
          registerSection={registerSection}
        />
      ))}
    </Flex>
  );
}

export default HomeContests;
